export const colors = {
  bg: '#0f111a',
  surface: '#1a1d2e',
  surfaceHover: '#232740',
  border: '#2a2e42',
  primary: '#6366f1',    // Indigo
  primaryHover: '#818cf8',
  success: '#10b981',
  warning: '#f59e0b',
  danger: '#ef4444',
  dangerHover: '#f87171',
  text: '#e2e8f0',
  textSecondary: '#94a3b8',
  textMuted: '#64748b',
  white: '#ffffff',
};

export const shadows = {
  card: '0 4px 24px rgba(0,0,0,0.3)',
  cardHover: '0 8px 32px rgba(99,102,241,0.15)',
  button: '0 2px 8px rgba(0,0,0,0.2)',
};

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
};
